export default "__VITE_ASSET__UZJz2Kmu__"